<script>
import VueTagsInput from "@johmun/vue-tags-input";
import modalEditContact from "../modals/modal-editcontact.vue";
import { useContacts } from "../../stores/modules/contacts";
import { useApproverGroups } from "../../stores/modules/approverGroups";

export default {
  name: "selectApprovers",
  props: ["SelectedApprovers", "index", "placeholder", "createNewContactText", "testingId", "isUpdateProofOptionsModal", "availableApprovers", "enableGroups"],
  components: {
    VueTagsInput,
    modalEditContact,
  },
  data() {
    return {
      instanceId: this.$A.GetUUID(),
      tag: "",
      tags: [],
      autoComplete: [],
      contacts: [],
      contactStore: null,
      groupStore: null,
    };
  },
  async mounted() {
    this.contactStore = useContacts();
    if (this.enableGroups) {
      this.groupStore = useApproverGroups();
      await this.groupStore.loadGroups();
    }
    await this.loadContacts(true);

    this.registerEvents();
    if (Array.isArray(this.SelectedApprovers))
      this.setSelectedApprovers(this.SelectedApprovers);
  },
  methods: {
    formatContactText(contact) {
      return `${contact.name.capitalize()} (${contact.email.toLowerCase()})`;
    },
    formatGroupText(group) {
      const count = (group.approverIds || []).length;
      return `${group.name} (Group · ${count} ${count === 1 ? "contact" : "contacts"})`;
    },
    getSelectedApprovers() {
      return this.contacts.filter(a => a.selected);
    },
    setSelectedApprovers: function (selectedApprovers) {
      const selectedIds = new Set(selectedApprovers.map(a => a.id));
      for(let contact of this.contacts) {
        contact.selected = selectedIds.has(contact.id);
      }
      this.calcTags();
    },
    calcTags: function () {
      this.tags = this.contacts
        .filter(t => t.selected)
        .map(t => ({
          text: this.formatContactText(t),
        }));
    },
    loadContacts: async function (ignoreSelectionStatus, forceUpdate) {
      let contacts = this.contacts;

      if (Array.isArray(this.availableApprovers)) {
        contacts = this.availableApprovers;
      } else {
        if (contacts.length === 0 || (forceUpdate !== undefined && forceUpdate)) {
          await this.contactStore.loadContacts();
          contacts = this.contactStore.contacts;
        }
      }

      let autoComplete = [];
      let selectedMap = new Map();
      if (Array.isArray(contacts)) {
        for (let i = 0; i < this.contacts.length; i++) {
          selectedMap.set(this.contacts[i].id, this.contacts[i].selected);
        }
        for (let i = 0; i < contacts.length; i++) {
          autoComplete.push({
            text:
                contacts[i].name.capitalize() +
                " (" +
                contacts[i].email.toLowerCase() +
                ")",
          }); //+" - "+approvers[i].email
          if (!ignoreSelectionStatus) {
            contacts[i].selected = false;
          } else {
            contacts[i].selected = selectedMap.get(contacts[i].id) || false;
          }
        }
        this.contacts = contacts;
        this.autoComplete = autoComplete;
        this.calcTags();
      }
    },
    registerEvents: function () {
      let self = this;
      this.$root.$on(
          "confirmed::selecting::approver::" + this.instanceId,
          async (selectedUsersFromModal) => {
            await self.loadContacts(false, true);
            self.calcTags();
          }
      );
      // this.$root.$on('load:contacts', async function () {
      //   await self.loadContacts(true, true);
      // });
    },
    approverCreated: async function (approver) {
      // approver = approver.approver;
      // console.log(approver, "created new approver and adding it to the selected list");
      approver.selected = true;
      this.contacts.push(approver);
      this.calcTags();
      // this.$root.$emit('load:contacts');
        let self = this;
        setTimeout(async function () {
          await self.loadContacts(true, true);
          self.$emit("contactsChanged");
        }, 500);
    },
    selectedContactChanged(newTags) {
      // A selected group tag unfurls into its member contacts and the
      // group tag itself is discarded.
      const groupsByText = new Map(
        this.availableGroups.map(g => [this.formatGroupText(g), g])
      );
      const unfurledIds = new Set();
      let selectedGroup = null;
      const contactTags = [];
      newTags.forEach(tag => {
        const group = groupsByText.get(tag.text);
        if (group) {
          selectedGroup = group;
          (group.approverIds || []).forEach(id => unfurledIds.add(id));
        } else {
          contactTags.push(tag);
        }
      });

      const selectedTexts = new Set(contactTags.map(tag => tag.text));
      this.contacts.forEach(contact => {
        const contactText = this.formatContactText(contact);
        contact.selected = selectedTexts.has(contactText) || unfurledIds.has(contact.id);
      });
      if (selectedGroup) {
        if ((selectedGroup.approverIds || []).length === 0) {
          this.$A.AlertUser("This group has no contacts in it yet.");
        }
        this.tag = "";
        this.calcTags();
      }
      this.$emit("contactsChanged");
    },
  },
  computed: {
    availableGroups: function () {
      if (!this.enableGroups || this.groupStore === null) return [];
      return this.groupStore.groups;
    },
    getAutoComplete: function () {
      let curTag = this.tag;

      const groupItems = this.availableGroups
          .map((g) => ({ text: this.formatGroupText(g) }))
          .filter((a) => a.text.toLowerCase().indexOf(curTag.toLowerCase()) > -1);

      return groupItems
          .concat(
              this.autoComplete
                  .filter((a) => a.text.toLowerCase().indexOf(curTag.toLowerCase()) > -1)
          )
          .splice(0, 20);
    },
  },
};
</script>

<template>
  <div>
    <div :id="instanceId" class="d-flex justify-content-md-start col-md-12 px-0">
      <vue-tags-input
          :placeholder=this.$props.placeholder
          v-model="tag"
          :tags="tags"
          :autocomplete-items="getAutoComplete"
          :add-only-from-autocomplete="true"
          @tags-changed="(newTags) => selectedContactChanged(newTags)"
          :data-cy=this.$props.testingId
          :class="!isUpdateProofOptionsModal ? 'px-0 w-100 col-11': 'px-0 w-100 col-12'"
      >
      </vue-tags-input>
      <!--  Add Icon -->
      <a v-b-modal="instanceId" class="add-icon col-md-1 pl-2"
         :data-cy="`${this.$props.testingId}-stage-${index}`"
         v-show="!isUpdateProofOptionsModal">
        <b-img src="/img/add-member-button.svg" style="margin-top: 2px"></b-img>
        <b>{{ this.$props.createNewContactText }}</b>
      </a>
    </div>
    <modalEditContact v-on:approverCreated="approverCreated" :instanceId="instanceId" :index="index + 1"
                      :key="instanceId+'modalEditContact'"/>
  </div>
</template>

<style scoped>

/deep/ .ti-new-tag-input-wrapper input::placeholder {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #909092;
}

/deep/ .ti-tag {
  background: #D1F6D4 !important;
  border-radius: 10px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #3E3E40 !important;
}


</style>